import { render } from "./BenchmarkManagerEditorDetails.vue?vue&type=template&id=153b6fc3"
import script from "./BenchmarkManagerEditorDetails.vue?vue&type=script&lang=js"
export * from "./BenchmarkManagerEditorDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__